'use client';

import { useState, type FC } from 'react';
import styles from './ClientInactiveCompanyOverlay.module.css';
import { Button, ButtonGroup, Text, Flex, Overlay } from '@/_components';
import { ClientInactiveCompanyOverlayProps } from './ClientInactiveCompanyOverlay.types';

export const ClientInactiveCompanyOverlay: FC<
  ClientInactiveCompanyOverlayProps
> = ({ signOut }) => {
  const [isLoading, setLoading] = useState<boolean>(false);

  const handleSignOut = (): void => {
    setLoading(true);
    signOut();
  };

  return (
    <>
      <Overlay isCentered={true} onClose={() => {}}>
        <Flex
          padding={12}
          className={styles.clientInactiveCompanyOverlay}
          isColumn={true}
          gap={8}
        >
          <Text type="paragraph">
            Your account does not have active entities to view. Please contact
            your firm.
          </Text>
          <ButtonGroup align="right">
            <Button
              intent="danger-secondary"
              value="Sign out"
              onClick={handleSignOut}
              isLoading={isLoading}
              isDisabled={isLoading}
            />
          </ButtonGroup>
        </Flex>
      </Overlay>
    </>
  );
};
